import { omit, pick } from 'lodash'

interface DownloadProps {
  data: string
  fileName: string
  fileType: string
}

const downloadFile = ({ data, fileName, fileType }: DownloadProps) => {
  // Create a blob with the data we want to download as a file
  const blob = new Blob([data], { type: fileType })
  // Create an anchor element and dispatch a click event on it
  // to trigger a download
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

export const omitSensitiveFields = (appInstanceForExport: any) => {
  const cleansedDataSourcesForExport = appInstanceForExport?.dataSources?.map(
    (dataSource: { configuration: any; iconUrl: string; type?: string }) => {
      const cleansedDataSource = {
        ...pick(dataSource, ['vendorName', 'key'])
      }
      return cleansedDataSource
    }
  )
  return { ...appInstanceForExport, dataSources: cleansedDataSourcesForExport }
}

export const getAppForExport = (appWithWorkflow: any) => {
  const updatedAppWithWorkflow = {
    ...omit(appWithWorkflow, ['audience'])
  }
  const appInstanceWithoutPasswords = omitSensitiveFields(updatedAppWithWorkflow)

  downloadFile({
    data: JSON.stringify(appInstanceWithoutPasswords),
    fileName: `${appInstanceWithoutPasswords.name}.json`,
    fileType: 'text/json'
  })
}
